const ROUTE_CONFIG_FIELDS = [
  'runtimeModelId',
  'inferenceProviderId',
  'routeInferenceProviderId',
  'actualInferenceProviderId',
  'desktopHostId',
  'billingModelId',
  'providerCompatibility',
  'apiBase',
  'modelsDevProviderId',
  'promptTemplate'
]

const MODEL_REQUEST_CONFIG_VERSION = 1

const pickModelRouteConfig = value => {
  if (!value || typeof value !== 'object') return null
  const result = {}
  for (const field of ROUTE_CONFIG_FIELDS) {
    if (value[field] !== undefined) result[field] = value[field]
  }
  return result.routeInferenceProviderId || result.inferenceProviderId ? result : null
}

const mergeModelRequestConfigs = (modelIds, generationConfigs = {}, routeConfigs = {}) => {
  const result = {}
  for (const modelId of modelIds || []) {
    result[modelId] = {
      ...(generationConfigs[modelId] || {}),
      ...(routeConfigs[modelId] || {})
    }
  }
  return result
}

const mergeChatRequestConfigs = (modelIds, messageConfigs = {}, requestConfigs = {}) => {
  const result = {}
  for (const modelId of modelIds || []) {
    result[modelId] = {
      ...(messageConfigs[modelId] || {}),
      ...(requestConfigs[modelId] || {})
    }
  }
  return result
}

const requireExplicitInferenceRoutes = (modelIds, configs = {}) => {
  const missing = []
  for (const modelId of modelIds || []) {
    if (!pickModelRouteConfig(configs[modelId])) missing.push(modelId)
  }
  if (missing.length) {
    throw new Error(`Select an inference provider for ${missing.join(', ')}`)
  }
  return configs
}

const selectedModelRouteConfigsFromOptions = (modelIds, options = {}) => {
  const modelOptions = options.models || {}
  const runtimeOptions = modelOptions.selectedModelRuntimeOptions || {}
  const result = {}
  for (const modelId of modelIds || []) {
    const route = pickModelRouteConfig(runtimeOptions[modelId])
    if (route) result[modelId] = route
  }
  return result
}

const routeProviderId = config => config && (
  config.routeInferenceProviderId || config.inferenceProviderId
)

const mergeSelectedModelRouteConfigs = (modelIds, selectedConfigs = {}, liveConfigs = {}) => {
  const result = {}
  for (const modelId of modelIds || []) {
    const selected = selectedConfigs[modelId]
    const live = liveConfigs[modelId]
    if (selected && live && routeProviderId(selected) === routeProviderId(live)) {
      result[modelId] = { ...selected, ...live }
    } else if (selected) {
      result[modelId] = selected
    } else if (live) {
      result[modelId] = live
    }
  }
  return result
}

module.exports = {
  MODEL_REQUEST_CONFIG_VERSION,
  ROUTE_CONFIG_FIELDS,
  pickModelRouteConfig,
  mergeModelRequestConfigs,
  mergeChatRequestConfigs,
  requireExplicitInferenceRoutes,
  selectedModelRouteConfigsFromOptions,
  mergeSelectedModelRouteConfigs
}
